export const translations = {
  da: {
    nav: {
      about: "Om mig",
      services: "Ydelser",
      resources: "Ressourcer",
      contact: "Kontakt og info",
      therapy: "Terapi",
      coaching: "Coaching",
      compassion: "Compassionfokuseret Terapi (CFT)",
      living_abroad: "LIVING ABROAD",
      supervision: "Supervision",
      book_session: "Book samtale",
    },
    hero: {
      role: "Klinisk psykolog",
      name: "Kay Elizabeth Worsfold",
      title: "Psykolog Kay Elizabeth Worsfold",
      subtitle: "Et trygt og professionelt rum i hjertet af København, hvor du mødes med venlighed, nærvær og respekt",
      cta_book: "Book en samtale",
      cta_contact: "Kontakt mig",
    },
    welcome: {
      title: "Specialiseret terapi og coaching for udlændinge, der bor og arbejder i Danmark. Beliggende i centrum af København.",
      description1: "Jeg tilbyder et varmt og professionelt rum til at udforske og hjælpe dig med at håndtere de udfordringer, du står overfor.",
      description2: "Jeg er autoriseret klinisk psykolog med mere end 20 års erfaring med at tilbyde coaching og terapi på engelsk og dansk.",
      description3: "Efter min egen flytning til Danmark fra Storbritannien i slutningen af mine 20'ere har jeg på egen krop oplevet mange af de udfordringer, man møder, når man flytter til et nyt land. Kombineret med klinisk indsigt fra at støtte udlændinge gennem årene, er jeg godt rustet til at hjælpe dig med at håndtere de praktiske og følelsesmæssige krav, der følger med at falde til i livet og arbejdet i Danmark."
    },
    treatment: {
      title: "Behandling",
      description: "I min praksis har jeg specialiseret mig i Compassionfokuseret Terapi (CFT) kombineret med mindfulness og kognitiv adfærdsterapi. Denne kombination giver dig de mest effektive, evidensbaserede redskaber til at dæmpe selvkritik, regulere nervesystemet og skabe varig trivsel.",
      experience: "Jeg har over 20 års erfaring som klinisk psykolog, herunder mange år i privatpraksis, og ambulant psykiatri. Jeg har også specialiseret mig i arbejdsrelateret stress under tidligere ansættelse på Stressreduktionsklinikken på Bispebjerg Hospital.\n\nForud for min psykologkarriere har jeg 10 års erfaring fra det private erhvervsliv, heraf 3 år som leder.",
      offerings: "Jeg tilbyder behandling af stress, angst, OCD, depression og lavt selvværd samt hjælp til håndtering af sorg og livskriser. Jeg tilbyder også forløb med fokus på hjælp til selvudvikling og forbedret trivsel. Jeg tilbyder desuden supervision af psykologer og andre faggrupper.",
    },
    compassion_focus: {
      tag: "MIN SPECIALISERING",
      title: "Compassionfokuseret Terapi (CFT)",
      subtitle: "Få beroliget angst og selvkritik, opnå bedre følelsesmæssig balance og find ind til din indre styrke.",
      description1: "CFT er en struktureret, evidensbaseret psykoterapeutisk retning som omfavner elementer fra kognitiv adfærdsterapi, mindfulness og psykodynamisk terapi.",
      description2: "",
      cta: "Læs mere om CFT",
      benefits: [
        {
          title: "Få beroliget angst og selvkritik",
          desc: "Støtte til at forstå udfordringerne uden at bebrejde dig selv"
        },
        {
          title: "Bedre følelsesmæssig balance",
          desc: "Sammen udforsker vi kloge og selvomsorgsfulde måder at håndtere dine følelser på"
        },
        {
          title: "Find ind til din indre styrke",
          desc: "Støtte til at tage konkrete skridt mod mål der bygger på selvaccept og omsorg for dig selv"
        }
      ]
    },
    problem: {
      title: "Specialiseret behandling og støtte",
      description: "Jeg tilbyder evidensbaseret terapi og kurser til dig, der ønsker at håndtere livets udfordringer med større indsigt og medfølelse.",
    },
    benefits: {
      title: "Fokusområder",
      items: [
        "Stress og udbrændthed",
        "Angst og OCD",
        "Depression",
        "Lavt selvværd",
        "Sorg og livskriser",
        "Selvudvikling og trivsel",
      ],
    },
    three_circles: {
      title: "De tre følelsesregulerende systemer",
      subtitle: "Grafik og begreber tilpasset fra Gilbert, 2009, The Three Circles Model of Emotion Regulation.",
      description: "Vores hjerne og nervesystem regulerer vores følelser gennem tre overordnede systemer, som konstant påvirker hinanden. CFT (Compassion Focused Therapy) hjælper os med at bringe disse systemer i bedre balance.",
      threat: {
        title: "Trusselssystemet (Threat system)",
        desc: "Forbundet med selvbeskyttelse & overlevelse. Kan være forbundet med angst & selvbebrejdelse."
      },
      drive: {
        title: "Præstationssystemet (Drive system)",
        desc: "Forbundet med motivation, lyst, ressourcer & præstation. Kan være forbundet med overpræstation & perfektionisme."
      },
      soothe: {
        title: "Det beroligende system (Soothe system)",
        desc: "Forbundet med ro, forbindelse, tryghed, restitution & leg."
      }
    },
    services: {
      title: "Ydelser",
      cta: "Læs mere",
    },
    about_short: {
      title: "Min baggrund",
      description: "Jeg er uddannet psykolog (cand.psych.) og har en ph.d.-grad i klinisk psykologi fra Københavns Universitet. Jeg er autoriseret af Psykolognævnet og godkendt specialist og supervisor i klinisk psykologi/psykoterapi.",
      cta: "Læs hele min baggrund",
    },
    testimonials: {
      title: "Udtalelser",
    },
    resources: {
      title: "Mindfulness og Compassion Ressourcer",
      audio: "Lydfiler",
      links: "Links til andre ressourcer",
      cta: "Se alle ressourcer",
    },
    contact: {
      title: "Kontakt og info",
      subtitle: "Du er velkommen til at kontakte mig for nærmere information.",
      phone: "Telefon",
      email: "Mail",
      address: "Adresse",
      cta_call: "Ring nu",
      cta_email: "Send mail",
      prices: "Priser (selvbetalende klienter)",
      insurance: "Sundhedsforsikringer",
      sygeforsikring: "Sygeforsikringen ’danmark’",
      referral: "Henvisning fra egen læge",
      payment: "Betaling",
      cancellation: "Afbud",
      transport: "Transport",
    },
    footer: {
      cvr: "CVR: 34853991",
      rights: "Alle rettigheder forbeholdes",
      privacy: "Privatlivspolitik",
    },
    common: {
      loading: "Indlæser...",
      back: "Tilbage",
    }
  },
  en: {
    nav: {
      about: "About me",
      services: "Services",
      resources: "Resources",
      contact: "Contact and info",
      therapy: "Therapy",
      coaching: "Coaching",
      compassion: "Compassion Focused Therapy",
      living_abroad: "Living abroad",
      supervision: "Supervision",
      book_session: "Book a Session",
    },
    hero: {
      role: "Clinical Psychologist",
      name: "Kay Elizabeth Worsfold",
      title: "Psychologist Kay Elizabeth Worsfold",
      subtitle: "Specialist Therapy and Coaching for Internationals living and working in Denmark. Based in the center of Copenhagen.",
      cta_book: "Book a Session",
      cta_contact: "Contact Me",
    },
    welcome: {
      title: "I offer a warm and professional space to help you to deal with the challenges you are facing",
      description1: "",
      description2: "I am a licensed Clinical Psychologist with more than 20 years of experience providing coaching and therapy in English and Danish.",
      description3: "Following my own move to Denmark from the UK in my late 20’s, I have experienced firsthand many of the challenges people face when relocating. Combined with clinical insights from supporting Internationals over the years, I am well positioned to help you to manage the practical and emotional demands of settling into life and work in Denmark."
    },
    treatment: {
      title: "Treatment",
      description: "In my practice, I specialize in compassion-focused therapy (CFT) combined with mindfulness and cognitive behavioral therapy. This combination provides you with the most effective, evidence-based tools to quiet self-criticism, regulate your nervous system, and create lasting well-being.",
      experience: "Over 20 years’ experience as a clinical psychologist, including many years in private practice, out-patient psychiatry and specialization in work-related stress at the Stress Reduction Clinic at Bispebjerg Hospital.\n\nPrior to my work as a psychologist, I have 10 years of experience from the international financial sector, including 3 years in a leadership role.",
      offerings: "I offer treatment for stress, anxiety, OCD, depression, and low self-esteem, as well as help managing grief and life crises. I also offer support focused on self-development and improved well-being. I also offer supervision for psychologists and other professional groups.",
    },
    compassion_focus: {
      tag: "MY SPECIALISATION",
      title: "Compassion Focused Therapy (CFT)",
      subtitle: "Quiet anxiety and self-criticism, find emotional balance and reconnect with your resources.",
      description1: "CFT is a structured, evidence-based approach and especially helpful in supporting you to navigate the challenges of building a life and career in Denmark.",
      description2: "I hold the British Psychological Society approved Post Graduate Diploma in CFT.",
      cta: "READ MORE ABOUT CFT",
      benefits: [
        {
          title: "Quiet anxiety and self-criticism",
          desc: "Support to understand the challenges without blaming yourself"
        },
        {
          title: "Find emotional balance",
          desc: "Looking together at skilled responses to identity shifts & pressures"
        },
        {
          title: "Reconnect with your resources",
          desc: "Shifting from burnout or self-doubt towards self-validating & self-compassionate goals"
        }
      ]
    },
    problem: {
      title: "Specialized Treatment and Support",
      description: "I offer evidence-based therapy and courses for those who wish to handle life's challenges with greater insight and compassion.",
    },
    benefits: {
      title: "Focus Areas",
      items: [
        "Stress and Burnout",
        "Anxiety and OCD",
        "Depression",
        "Low Self-esteem",
        "Grief and Life Crises",
        "Self-development and Well-being",
      ],
    },
    three_circles: {
      title: "The Three Emotion Regulation Systems",
      subtitle: "Graphic and concepts adapted from Gilbert, 2009, The Three Circles Model of Emotion Regulation.",
      description: "Our brain and nervous system regulate our emotions through three primary systems that constantly interact. CFT (Compassion Focused Therapy) helps us bring these systems into a healthier balance.",
      threat: {
        title: "Threat system",
        desc: "Linked to self-preservation & survival - Can be linked to anxiety & self-blaming."
      },
      drive: {
        title: "Drive system",
        desc: "Linked to motivation, achievement, resources & performance. Can be linked to overachievement & perfectionism."
      },
      soothe: {
        title: "Soothe system",
        desc: "Linked to calm, connection, safety, recovery & play."
      }
    },
    services: {
      title: "Services",
      cta: "Read more",
    },
    about_short: {
      title: "My Background",
      description: "I am a trained psychologist (cand.psych.) and hold a PhD in clinical psychology from the University of Copenhagen. I am authorized by the Psychology Board and an approved specialist and supervisor in clinical psychology/psychotherapy.",
      cta: "Read my full background",
    },
    testimonials: {
      title: "Testimonials",
    },
    resources: {
      title: "Mindfulness and Compassion Resources",
      audio: "Audio Files",
      links: "Links to other resources",
      cta: "See all resources",
    },
    contact: {
      title: "Contact and Info",
      subtitle: "You are welcome to contact me for further information.",
      phone: "Phone",
      email: "Email",
      address: "Address",
      cta_call: "Call now",
      cta_email: "Send email",
      prices: "Prices (self-paying clients)",
      insurance: "Health Insurance",
      sygeforsikring: "Sygeforsikringen ’danmark’",
      referral: "Referral from GP",
      payment: "Payment",
      cancellation: "Cancellation",
      transport: "Transport",
    },
    footer: {
      cvr: "CVR: 34853991",
      rights: "All rights reserved",
      privacy: "PRIVACY POLICY",
    },
    common: {
      loading: "Loading...",
      back: "Back",
    }
  }
};

